import { Component, Input, HostListener, ElementRef } from '@angular/core';

import { Router } from '@angular/router';

import { AdvertiserContact, BusinessService } from '../../services/business.service';
import { BusinessContactComponent } from '../business-contact/business-contact.component';
import { InquiryService } from '../../services/inquiry.service';

@Component({
    selector: 'app-contact-menu',
    imports: [BusinessContactComponent],
    templateUrl: './contact-menu.component.html',
    styleUrls: ['./contact-menu.component.scss']
})
export class ContactMenuComponent {
  @Input() phone: string = '';
  @Input() itemName: string = '';
  @Input() itemId: number = 0;
  @Input() chatRoute: string = '/chat';
  @Input() accentColor: string = '#e8723a';
  /** SCRUM-132: which button edge the dropdown is anchored to. */
  @Input() menuAlign: 'left' | 'right' = 'left';
  /** SCRUM-287 — "פרטי העסק" shown at the top of the menu when switched on. */
  @Input() businessContact: AdvertiserContact | null = null;
  @Input() businessLabel: string | null = null;
  @Input() sellerId: number | null = null;

  isOpen = false;

  constructor(private router: Router, private el: ElementRef, private business: BusinessService,
              private inquiries: InquiryService) {}

  toggle(event: Event) {
    event.stopPropagation();
    event.preventDefault();
    this.isOpen = !this.isOpen;
  }

  /**
   * WhatsApp → a message box on the page. The backend delivers it to the
   * seller's inbox and, if the seller opted in, to the seller's WhatsApp from
   * our business number — the buyer never leaves the site. When the feature
   * is off the dialog falls back to the old wa.me link by itself.
   */
  openWhatsApp(event: Event) {
    event.stopPropagation();
    event.preventDefault();
    this.inquiries.open({ adId: this.itemId, adName: this.itemName, phone: this.phone });
    this.isOpen = false;
  }

  makeCall(event: Event) {
    event.stopPropagation();
    // SCRUM-267 — "tap to call", never counted as a completed call.
    this.business.track('phone_tap', { ad_id: this.itemId });
    window.location.href = `tel:${this.phone}`;
    this.isOpen = false;
  }

  /** "צ'אט באתר" is the same in-site conversation. */
  openChat(event: Event) {
    this.openWhatsApp(event);
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event) {
    if (!this.el.nativeElement.contains(event.target)) {
      this.isOpen = false;
    }
  }
}